import React from 'react';
import {
  Box,
  Heading,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  Flex,
} from '@chakra-ui/react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  error?: string | null;
  minH?: string;
  children: React.ReactNode;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  isLoading = false,
  error = null,
  minH = '300px',
  children,
}) => {
  return (
    <Box
      bg="white"
      shadow="md"
      borderWidth="1px"
      borderRadius="md"
      p={5}
      minH={minH}
      w="100%"
    >
      <Box mb={3}>
        <Heading size="sm" fontFamily="TT Interphases Pro, Inter, sans-serif">
          {title}
        </Heading>
        {subtitle && (
          <Text fontSize="xs" color="gray.500" mt={1}>
            {subtitle}
          </Text>
        )}
      </Box>

      {isLoading ? (
        <Flex justify="center" align="center" minH="200px">
          <Spinner size="lg" color="blue.500" />
        </Flex>
      ) : error ? (
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          {error}
        </Alert>
      ) : (
        children
      )}
    </Box>
  );
};

export default ChartCard;
